import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createBlock(_component_el_aside, {
    width: "230px",
    class: "sidebar"
  }, {
    default: _withCtx(() => [
      (!_ctx.isCostApp)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 0,
            class: "el-menu-vertical-demo",
            "background-color": "#333",
            "text-color": "#fff",
            "active-text-color": "#ffd04b",
            "default-active": _ctx.activeMenuItem
          }, {
            default: _withCtx(() => [
              (_ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    index: "/users",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMenuClick('/users')))
                  }, {
                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                      _createElementVNode("span", null, "Пользователи", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles, _ctx.managerRoles, _ctx.universityManagerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: "/students",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMenuClick('/students')))
                  }, {
                    default: _withCtx(() => _cache[66] || (_cache[66] = [
                      _createElementVNode("span", null, "Обучающиеся", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles, _ctx.managerRoles, _ctx.universityManagerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 2,
                    index: "/military-students",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMenuClick('/military-students')))
                  }, {
                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                      _createElementVNode("span", null, "Военная кафедра", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 3,
                    index: "/student-credits",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMenuClick('/student-credits')))
                  }, {
                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                      _createElementVNode("span", null, "Корректировка кредитов", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 4,
                    index: "/students-social-groups",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMenuClick('/students-social-groups')))
                  }, {
                    default: _withCtx(() => _cache[69] || (_cache[69] = [
                      _createElementVNode("span", null, "Социальные группы", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 5,
                    index: "/students-social-payment",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMenuClick('/students-social-payment')))
                  }, {
                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                      _createElementVNode("span", null, "Социальные выплаты", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 6,
                    index: "/student-training-duration",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMenuClick('/student-training-duration')))
                  }, {
                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                      _createElementVNode("span", null, "Количества месяцев обучения", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.hasAccess(_ctx.universityManagerRoles) && _ctx.isUniversity(_ctx.UniversityEnum.KAZAKH_NATIONAL_WOMEN_PEDAGOGICAL_UNIVERSITY)) || _ctx.hasAccess(_ctx.managerRoles) || _ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 7,
                    index: "/students-grants-nutrition",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMenuClick('/students-grants-nutrition')))
                  }, {
                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                      _createElementVNode("span", null, "Питание студентов-грантников", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 8,
                    index: "/students-marine-practice",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleMenuClick('/students-marine-practice')))
                  }, {
                    default: _withCtx(() => _cache[73] || (_cache[73] = [
                      _createElementVNode("span", null, "Морская практика", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 9,
                    index: "/students-flight-practice",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleMenuClick('/students-flight-practice')))
                  }, {
                    default: _withCtx(() => _cache[74] || (_cache[74] = [
                      _createElementVNode("span", null, "Летная практика", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.adminReadOnlyRoles]))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 10,
                    index: "/acts/reconciliation",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleMenuClick('/acts/reconciliation')))
                  }, {
                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                      _createElementVNode("span", null, "Сверка актов", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.adminReadOnlyRoles]))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 11,
                    index: "/acts/acceptance",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleMenuClick('/acts/acceptance')))
                  }, {
                    default: _withCtx(() => _cache[76] || (_cache[76] = [
                      _createElementVNode("span", null, "Принятие актов", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.accountantRoles, ..._ctx.universityManagerRoles]))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 12,
                    index: "/invoice/reconciliation",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleMenuClick('/invoice/reconciliation')))
                  }, {
                    default: _withCtx(() => _cache[77] || (_cache[77] = [
                      _createElementVNode("span", null, "Работа с ЭСФ", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.hasAccess(_ctx.universityManagerRoles) && _ctx.isUniversity(_ctx.UniversityEnum.KORKYT_ATA_KYZYLORDA_UNIVERSITY)) || _ctx.hasAccess(_ctx.managerRoles) || _ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 13,
                    index: "/eco-payment",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleMenuClick('/eco-payment')))
                  }, {
                    default: _withCtx(() => _cache[78] || (_cache[78] = [
                      _createElementVNode("span", null, "Экологическая выплата", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.adminReadOnlyRoles]))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 14,
                    index: "/advance-deduction",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleMenuClick('/advance-deduction')))
                  }, {
                    default: _withCtx(() => _cache[79] || (_cache[79] = [
                      _createElementVNode("span", null, "Авансирование/Удержание", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.adminReadOnlyRoles]) || _ctx.isUniversity(_ctx.UniversityEnum.NUR_MUBARAK))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 15,
                    index: "/intergov-expenses",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleMenuClick('/intergov-expenses')))
                  }, {
                    default: _withCtx(() => _cache[80] || (_cache[80] = [
                      _createElementVNode("span", null, "Расходы по межправ", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles, _ctx.universityRectorRoles, _ctx.adminRoles, _ctx.auditRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 16,
                    index: "/reports",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleMenuClick('/reports')))
                  }, {
                    default: _withCtx(() => _cache[81] || (_cache[81] = [
                      _createTextVNode(" Отчеты ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.universityManagerRoles, _ctx.managerRoles, _ctx.universityRectorRoles, _ctx.adminRoles, _ctx.auditRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 17,
                    index: "/reports-1course",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleMenuClick('/reports-1course')))
                  }, {
                    default: _withCtx(() => _cache[82] || (_cache[82] = [
                      _createTextVNode(" Отчеты(первокурсники) ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.accountantRoles, _ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 18,
                    index: "/reports-1c",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleMenuClick('/reports-1c')))
                  }, {
                    default: _withCtx(() => _cache[83] || (_cache[83] = [
                      _createTextVNode(" Отчеты на 1С ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.managerRoles, _ctx.adminRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 19,
                    index: "/summary-social-reports",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleMenuClick('/summary-social-reports')))
                  }, {
                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                      _createTextVNode(" Сводный отчет (Соц) ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.managerRoles, _ctx.adminRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 20,
                    index: "/summary-reports",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleMenuClick('/summary-reports')))
                  }, {
                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                      _createTextVNode(" Сводный отчет ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 21,
                    index: "/dictionaries",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleMenuClick('/dictionaries')))
                  }, {
                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                      _createElementVNode("span", null, "Справочники", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.adminRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 22,
                    index: "/settings",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleMenuClick('/settings')))
                  }, {
                    default: _withCtx(() => _cache[87] || (_cache[87] = [
                      _createElementVNode("span", null, "Настройки", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.hasAccess(_ctx.adminRoles, _ctx.adminReadOnlyRoles))
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 23,
                    index: "/events",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleMenuClick('/events')))
                  }, {
                    default: _withCtx(() => _cache[88] || (_cache[88] = [
                      _createElementVNode("span", null, "Логи пользователей", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["default-active"]))
        : _createCommentVNode("", true),
      (_ctx.isCostApp)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 1,
            class: "el-menu-vertical-demo",
            "background-color": "#333",
            "text-color": "#fff",
            "active-text-color": "#ffd04b",
            "default-active": _ctx.activeMenuItem,
            "default-openeds": ['expenses']
          }, {
            default: _withCtx(() => [
              (_ctx.hasAccess([..._ctx.managerRoles, ..._ctx.adminRoles, ..._ctx.adminReadOnlyRoles, ..._ctx.universityManagerRoles]))
                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    key: 0,
                    index: "expenses"
                  }, {
                    title: _withCtx(() => _cache[89] || (_cache[89] = [
                      _createElementVNode("span", null, "Расходы", -1)
                    ])),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/salary-bonus",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleMenuClick('/expenses/salary-bonus')))
                      }, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createElementVNode("span", null, "111 - Зарплата", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/treatment-benefit",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleMenuClick('/expenses/treatment-benefit')))
                      }, {
                        default: _withCtx(() => _cache[91] || (_cache[91] = [
                          _createElementVNode("span", null, "113 - Лечпособие", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/ue-opvr",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleMenuClick('/expenses/ue-opvr')))
                      }, {
                        default: _withCtx(() => _cache[92] || (_cache[92] = [
                          _createElementVNode("span", null, "116 - ОПВР", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/ue-social-tax",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleMenuClick('/expenses/ue-social-tax')))
                      }, {
                        default: _withCtx(() => _cache[93] || (_cache[93] = [
                          _createElementVNode("span", null, "121 - Соцналог", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/ue-social-deduction",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.handleMenuClick('/expenses/ue-social-deduction')))
                      }, {
                        default: _withCtx(() => _cache[94] || (_cache[94] = [
                          _createElementVNode("span", null, "122 - Соцотчисл", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/ue-osms",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleMenuClick('/expenses/ue-osms')))
                      }, {
                        default: _withCtx(() => _cache[95] || (_cache[95] = [
                          _createElementVNode("span", null, "124 - ВОСМС", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/insurance-worker",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleMenuClick('/expenses/insurance-worker')))
                      }, {
                        default: _withCtx(() => _cache[96] || (_cache[96] = [
                          _createElementVNode("span", null, "123 - ОГПО работдатель", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/insurance-transport",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleMenuClick('/expenses/insurance-transport')))
                      }, {
                        default: _withCtx(() => _cache[97] || (_cache[97] = [
                          _createElementVNode("span", null, "123 - ОГПО транспорт", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/insurance-transfer",
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleMenuClick('/expenses/insurance-transfer')))
                      }, {
                        default: _withCtx(() => _cache[98] || (_cache[98] = [
                          _createElementVNode("span", null, "123 - ОГПО перевозка", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/nutrition",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleMenuClick('/expenses/nutrition')))
                      }, {
                        default: _withCtx(() => _cache[99] || (_cache[99] = [
                          _createElementVNode("span", null, "141 - Питание", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/water",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleMenuClick('/expenses/water')))
                      }, {
                        default: _withCtx(() => _cache[100] || (_cache[100] = [
                          _createElementVNode("span", null, "141 - Вода", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/medicines",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleMenuClick('/expenses/medicines')))
                      }, {
                        default: _withCtx(() => _cache[101] || (_cache[101] = [
                          _createElementVNode("span", null, "142 - Медикаменты", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/gsm",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleMenuClick('/expenses/gsm')))
                      }, {
                        default: _withCtx(() => _cache[102] || (_cache[102] = [
                          _createElementVNode("span", null, "144 - Гсм", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/coal",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.handleMenuClick('/expenses/coal')))
                      }, {
                        default: _withCtx(() => _cache[103] || (_cache[103] = [
                          _createElementVNode("span", null, "144 - Уголь дт", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/materials",
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleMenuClick('/expenses/materials')))
                      }, {
                        default: _withCtx(() => _cache[104] || (_cache[104] = [
                          _createElementVNode("span", null, "149 - Материалы", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/central-heating",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleMenuClick('/expenses/central-heating')))
                      }, {
                        default: _withCtx(() => _cache[105] || (_cache[105] = [
                          _createElementVNode("span", null, "151 - Центротопление", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/electricity",
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.handleMenuClick('/expenses/electricity')))
                      }, {
                        default: _withCtx(() => _cache[106] || (_cache[106] = [
                          _createElementVNode("span", null, "151 - Электр", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/water-heating",
                        onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.handleMenuClick('/expenses/water-heating')))
                      }, {
                        default: _withCtx(() => _cache[107] || (_cache[107] = [
                          _createElementVNode("span", null, "151 - Подогрев", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/wastewater",
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.handleMenuClick('/expenses/wastewater')))
                      }, {
                        default: _withCtx(() => _cache[108] || (_cache[108] = [
                          _createElementVNode("span", null, "151 - Вода", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/waste",
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.handleMenuClick('/expenses/waste')))
                      }, {
                        default: _withCtx(() => _cache[109] || (_cache[109] = [
                          _createElementVNode("span", null, "151 - мусор", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/communications",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.handleMenuClick('/expenses/communications')))
                      }, {
                        default: _withCtx(() => _cache[110] || (_cache[110] = [
                          _createElementVNode("span", null, "152 - связь", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/transport",
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.handleMenuClick('/expenses/transport')))
                      }, {
                        default: _withCtx(() => _cache[111] || (_cache[111] = [
                          _createElementVNode("span", null, "153 - транспуслуги", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/research",
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.handleMenuClick('/expenses/research')))
                      }, {
                        default: _withCtx(() => _cache[112] || (_cache[112] = [
                          _createElementVNode("span", null, "154 - Исследования", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/consulting",
                        onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.handleMenuClick('/expenses/consulting')))
                      }, {
                        default: _withCtx(() => _cache[113] || (_cache[113] = [
                          _createElementVNode("span", null, "156 - Консультац", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/image",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.handleMenuClick('/expenses/image')))
                      }, {
                        default: _withCtx(() => _cache[114] || (_cache[114] = [
                          _createElementVNode("span", null, "157 - Имиджевые", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/it",
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.handleMenuClick('/expenses/it')))
                      }, {
                        default: _withCtx(() => _cache[115] || (_cache[115] = [
                          _createElementVNode("span", null, "158 - ИТ", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/building-content",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.handleMenuClick('/expenses/building-content')))
                      }, {
                        default: _withCtx(() => _cache[116] || (_cache[116] = [
                          _createElementVNode("span", null, "159 - Содержаниезд", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/students",
                        onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.handleMenuClick('/expenses/students')))
                      }, {
                        default: _withCtx(() => _cache[117] || (_cache[117] = [
                          _createElementVNode("span", null, "159 - Студенты", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/trips-local",
                        onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.handleMenuClick('/expenses/trips-local')))
                      }, {
                        default: _withCtx(() => _cache[118] || (_cache[118] = [
                          _createElementVNode("span", null, "161 - Команд РК", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/trips-foreign",
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.handleMenuClick('/expenses/trips-foreign')))
                      }, {
                        default: _withCtx(() => _cache[119] || (_cache[119] = [
                          _createElementVNode("span", null, "162 - Команд за РК", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/social-help",
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.handleMenuClick('/expenses/social-help')))
                      }, {
                        default: _withCtx(() => _cache[120] || (_cache[120] = [
                          _createElementVNode("span", null, "163 - Матпомощь", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/other-gph",
                        onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.handleMenuClick('/expenses/other-gph')))
                      }, {
                        default: _withCtx(() => _cache[121] || (_cache[121] = [
                          _createElementVNode("span", null, "169 - Прочие гпх", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/international",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.handleMenuClick('/expenses/international')))
                      }, {
                        default: _withCtx(() => _cache[122] || (_cache[122] = [
                          _createElementVNode("span", null, "169 - Международные", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/tax",
                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.handleMenuClick('/expenses/tax')))
                      }, {
                        default: _withCtx(() => _cache[123] || (_cache[123] = [
                          _createElementVNode("span", null, "000 - Налоги", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/writeoff",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.handleMenuClick('/expenses/writeoff')))
                      }, {
                        default: _withCtx(() => _cache[124] || (_cache[124] = [
                          _createElementVNode("span", null, "000 - Списание", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/depreciation",
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.handleMenuClick('/expenses/depreciation')))
                      }, {
                        default: _withCtx(() => _cache[125] || (_cache[125] = [
                          _createElementVNode("span", null, "000 - Износ", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/loans",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.handleMenuClick('/expenses/loans')))
                      }, {
                        default: _withCtx(() => _cache[126] || (_cache[126] = [
                          _createElementVNode("span", null, "000 - Займы", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/contingent",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.handleMenuClick('/expenses/contingent')))
                      }, {
                        default: _withCtx(() => _cache[127] || (_cache[127] = [
                          _createElementVNode("span", null, "Контингент", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/summary-calculated",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.handleMenuClick('/expenses/summary-calculated')))
                      }, {
                        default: _withCtx(() => _cache[128] || (_cache[128] = [
                          _createElementVNode("span", null, "свод расчетные", -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, {
                        index: "/expenses/summary-vuz-svod",
                        onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.handleMenuClick('/expenses/summary-vuz-svod')))
                      }, {
                        default: _withCtx(() => _cache[129] || (_cache[129] = [
                          _createElementVNode("span", null, "ВУЗ СВОД", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_menu_item, {
                index: "pdf",
                onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.handleMenuPdf('/docs/cost-instruction.pdf')))
              }, {
                default: _withCtx(() => _cache[130] || (_cache[130] = [
                  _createElementVNode("span", null, " База знаний", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}